module.exports = __webpack_public_path__ + "img/banner-1.8685b6cf.jpg";